import { getAxiosInstance } from "../../../api";

export const exportUsers = async (params) => {
  const api = await getAxiosInstance();
  const response = await api.get(`admin/users/export`, {
    params,
    responseType: "blob",
  });
  return response;
};
